import { render, staticRenderFns } from "./LayoutVerticalCore.vue?vue&type=template&id=4a4993a0"
import script from "./LayoutVerticalCore.vue?vue&type=script&lang=js"
export * from "./LayoutVerticalCore.vue?vue&type=script&lang=js"
import style0 from "./LayoutVerticalCore.vue?vue&type=style&index=0&id=4a4993a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports